import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

// http://www.zhano.cn/JavaScript/68744.html
// https://driverjs.com/docs/configuration/

import { onMounted } from '@vue/composition-api'
import { MENU_STEPS } from './steps/menu.step'
import { setStore, getStore } from '@/util/store'

import store from '@/store'
export default function () {
  const startMenu = () => {
    const s1 = document.querySelector('#menuShowlogo')
    const s2 = document.querySelector('#menuShow')
    const s3 = document.querySelector('#commonMenu')
    const s4 = document.querySelector('#menuSearch')

    const flag = s1 && s2 && s3 && s4
    if (!flag) {
      return
    }
    const driverObj = driver({
      doneBtnText: '完成',
      closeBtnText: '关闭',
      nextBtnText: '下一步',
      prevBtnText: '上一步',
      showProgress: true,
      current: true,
      total: true,
      progressText: '{{current}} / {{total}}',
      allowClose: false,
      steps: MENU_STEPS,
      onNextClick: (ele, step) => {
        store.commit('SET_OPEN', true)
        setTimeout(() => {
          driverObj.moveNext()
        }, 100)
      },
      onPrevClick: (ele, step) => {
        if (step.element === '#menuShow') {
          store.commit('SET_OPEN', false)
        }
        driverObj.movePrevious()
      },
      onDestroyed: (ele) => {
        setStore({
          name: 'firstVisitEditor',
          content: true
        })
        store.commit('SET_OPEN', false)
      }
    })

    driverObj.drive()
  }

  onMounted(() => {
    const flag = getStore({ name: 'firstVisitEditor' })
    if (!flag) {
      // flag不存在，即当用户第一次访问该网页的时候，调用showTips，显示新手引导
      setTimeout(() => {
        startMenu()
      }, 3000)
      // startMenu()
    }
  })
}
